import oRequest from '@/libsV2/request.js';
const URL = {
    BASE_INFO: "archives/workorder/info", //工单基本信息
    CHECK_INFO:'archives/workorder/acceptance',//监理验收
    WORK_INFO:'archives/workorder/work',//工人工单
};
export const baseInfo = (data = {}) => {
    return oRequest.getData(URL.BASE_INFO, data);
};
export const checkInfo = (data = {}) => {
    return oRequest.getData(URL.CHECK_INFO, data);
};
export const workInfo = (data = {}) => {
    return oRequest.getData(URL.WORK_INFO, data);
};
